
import { createI18n } from 'vue-i18n';
import enLocale from '../locales/en-US';
import etLocale from '../locales/et-EE';
import ruLocale from '../locales/ru-RU';

const SUPPORTED_LOCALES = ['en-US', 'et-EE', 'ru-RU'];
const DEFAULT_LOCALE = 'en-US';

// Determine initial locale: prefer stored value, then browser language, then default
let initialLocale = DEFAULT_LOCALE;

try {
    const stored = localStorage.getItem('locale');
    if (stored && SUPPORTED_LOCALES.includes(stored)) {
        initialLocale = stored;
    } else if (navigator.language && SUPPORTED_LOCALES.includes(navigator.language)) {
        initialLocale = navigator.language;
    }
} catch {
    // Access to localStorage may fail in some environments; fall back to default
    initialLocale = DEFAULT_LOCALE;
}

const i18n = createI18n({
    legacy: false,
    locale: initialLocale,
    fallbackLocale: DEFAULT_LOCALE,
    messages: {
        'en-US': enLocale,
        'et-EE': etLocale,
        'ru-RU': ruLocale
    },
    silentTranslationWarn: true, // Suppress warnings for missing translations
    silentFallbackWarn: true, // Suppress warnings when fallback occur
    missing: () => {}
});

export default i18n;